import request from "@/api/request";

/**
 * 登录
 * @param {phone} data
 * @returns
 */
export function loginByPhone(data) {
  return request({
    url: "/api/login/phoneLogin",
    method: "post",
    data: data,
  });
}

/**
 * 根据手机号和验证码登录
 * @param {string} phone
 * @param {string} code
 * @returns
 */
export function loginByPhoneAndCode(phone, code) {
  return request({
    url: "/api/login/phoneCodeLogin",
    method: "post",
    data: {
      phone: phone,
      code: code,
    },
  });
}

export function whoami() {
  return request({
    url: "/api/login/whoami",
    method: "get",
  });
}

export function getCode(phone){
  return request({
    url: "/api/login/sendSms",
    method: "post",
    data: {
      phone: phone,
      code: null,
    }
  });
}
